module.exports = __webpack_public_path__ + "img/1516802514.6933a7a6.jpg";